import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgReload = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	...props,
	children: [/* @__PURE__ */ _jsx("polyline", { points: "23 4 23 10 17 10" }), /* @__PURE__ */ _jsx("path", { d: "M20.49 15a9 9 0 1 1-2.12-9.36L23 10" })]
});
export default SvgReload;
